import React, { useEffect, useState } from "react";
import { Modal } from "components/Modals/Modal";

// Components
import { ProfilePersonaModalSelect } from "./components/ProfilePersonaModalSelect/ProfilePersonaModalSelect";

// Hooks
import { usePersonaWizard } from "hooks/wizards/usePersonaWizard/usePersonaWizard";

// Localization
import { useTranslation } from "localization/localization";

// Utils
import { generateDisplayText } from "utils/personaUtils";

export const ProfilePersonaModal = ({
    handleShowPersonaSelectionModal,
    onProfileUpdateSuccess,
    shouldShowPersonaModal,
}) => {
    /**
     * Custom Hooks
     */

    const { t } = useTranslation();

    const {
        childPersonas,
        fetchAccount,
        fetchRootPersonas,
        handleSelectProfileChildPersona,
        handleSelectRootPersona,
        isLoadingChildPersonas,
        rootPersonas,
        setIsLoadingChildPersonas,
    } = usePersonaWizard({});

    /**
     * useEffect
     */

    useEffect(() => {
        shouldShowPersonaModal &&
            setDisplayText(generateDisplayText(lastChildPersonasArray));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [childPersonas]);

    useEffect(() => {
        shouldShowPersonaModal && fetchRootPersonas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldShowPersonaModal]);

    /**
     * useState
     */

    const [displayText, setDisplayText] = useState({
        header: t("persona_select_title", { ns: "onboarding" }),
        subHeader: t("persona_select_subtitle", { ns: "onboarding" }),
    });

    /**
     * Constants
     */

    const lastChildPersonasArray = childPersonas[childPersonas?.length - 1];

    /**
     * End Hooks
     */

    function onComplete() {
        fetchAccount();
        setIsLoadingChildPersonas(true);
        onProfileUpdateSuccess();
        localStorage.setItem("shouldShowProfileUpdateSuccess", true);
    }

    function onCloseModal() {
        handleShowPersonaSelectionModal(false);
        setDisplayText({
            header: t("persona_select_title", { ns: "onboarding" }),
            subHeader: t("persona_select_subtitle", { ns: "onboarding" }),
        });
    }

    return (
        <Modal
            headerText={displayText.header}
            headerSubText={displayText.subHeader}
            onClose={onCloseModal}
            onHide={onCloseModal}
            show={shouldShowPersonaModal}
        >
            <ProfilePersonaModalSelect
                childPersonas={childPersonas}
                handleSelectProfileChildPersona={
                    handleSelectProfileChildPersona
                }
                handleSelectRootPersona={handleSelectRootPersona}
                isLoadingChildPersonas={isLoadingChildPersonas}
                onComplete={onComplete}
                rootPersonas={rootPersonas}
            />
        </Modal>
    );
};
